// frontend/src/components/common/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const socials = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/share/18GBoEoRhQ/',
    path: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879v-6.99h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.99C18.343 21.128 22 16.991 22 12z'
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/twinklefanta?igsh=MXAxZHU4ank4M3NvdQ==',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z'
  },
  {
    label: 'Twitter',
    href: 'https://x.com/Twinkle_Fanta',
    path: 'M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.937 4.937 0 004.604 3.417 9.868 9.868 0 01-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0021.718-3.708 13.94 13.94 0 001.529-5.822c0-.21-.005-.42-.015-.63A9.935 9.935 0 0024 4.59z'
  },
  {
    label: 'YouTube',
    href: 'https://youtube.com/@pubji-toy?si=dJPmIC4nJiMXUb-S',
    path: 'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z'
  }
];

  return (
    <footer style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", position: 'relative', overflow: 'hidden', background: 'linear-gradient(160deg, #2d0a0a 0%, #1a0030 40%, #0d001a 100%)' }}>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;1,700&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

        @keyframes shimmerLine { 0%{transform:translateX(-100%)} 100%{transform:translateX(200%)} }
        @keyframes pulse       { 0%,100%{opacity:0.6;transform:scale(1)} 50%{opacity:1;transform:scale(1.15)} }
        @keyframes floatOrb    { 0%,100%{transform:translateY(0) scale(1)} 50%{transform:translateY(-18px) scale(1.04)} }

        .ft-shimmer { position:relative; overflow:hidden; }
        .ft-shimmer::after {
          content:''; position:absolute; top:0; left:0; right:0; bottom:0;
          background:linear-gradient(90deg,transparent,rgba(147,112,219,0.35),transparent);
          animation:shimmerLine 3.5s ease-in-out infinite;
        }

        .ft-social {
          width:38px; height:38px; border-radius:10px;
          display:flex; align-items:center; justify-content:center;
          background:rgba(147,112,219,0.12);
          border:1px solid rgba(147,112,219,0.2);
          transition:all 0.28s cubic-bezier(0.34,1.56,0.64,1);
          cursor:pointer;
        }
        .ft-social:hover {
          background:rgba(147,112,219,0.35);
          border-color:rgba(200,160,255,0.5);
          transform:translateY(-4px) scale(1.1);
          box-shadow:0 8px 24px rgba(147,112,219,0.4);
        }
        .ft-social svg { width:16px; height:16px; fill:#c4a0f0; transition:fill 0.2s; }
        .ft-social:hover svg { fill:#f0e0ff; }

        .ft-link {
          display:inline-flex; align-items:center; gap:8px;
          color:rgba(200,180,220,0.7);
          text-decoration:none; font-size:13.5px;
          transition:color 0.2s, gap 0.2s;
          padding:4px 0;
          cursor: pointer;
        }
        .ft-link::before {
          content:''; width:0; height:1.5px; border-radius:99px;
          background:linear-gradient(90deg,#9370DB,#C084FC);
          transition:width 0.28s ease;
          flex-shrink:0;
        }
        .ft-link:hover { color:#e8d0ff; gap:10px; }
        .ft-link:hover::before { width:14px; }

        .ft-contact-row {
          display:flex; align-items:flex-start; gap:12px;
          padding:10px 0;
          border-bottom:1px solid rgba(147,112,219,0.1);
          transition:border-color 0.2s;
        }
        .ft-contact-row:last-child { border-bottom:none; }
        .ft-contact-row:hover { border-color:rgba(147,112,219,0.3); }
        .ft-contact-icon {
          width:34px; height:34px; border-radius:10px;
          background:rgba(139,69,19,0.3);
          border:1px solid rgba(147,112,219,0.2);
          display:flex; align-items:center; justify-content:center;
          flex-shrink:0;
          transition:background 0.2s, transform 0.28s cubic-bezier(0.34,1.56,0.64,1);
        }
        .ft-contact-row:hover .ft-contact-icon { background:rgba(147,112,219,0.25); transform:scale(1.1); }
        .ft-contact-icon svg { width:15px; height:15px; color:#C084FC; stroke:#C084FC; }

        .ft-stat {
          padding:10px 18px; border-radius:12px;
          background:rgba(139,69,19,0.2);
          border:1px solid rgba(147,112,219,0.2);
          text-align:center;
          transition:all 0.25s;
        }
        .ft-stat:hover { background:rgba(147,112,219,0.2); border-color:rgba(192,132,252,0.4); transform:translateY(-3px); }

        .ft-bot-link {
          color:rgba(180,160,200,0.55); font-size:12px; text-decoration:none;
          position:relative; transition:color 0.2s;
          padding-bottom:2px;
          cursor: pointer;
        }
        .ft-bot-link::after { content:''; position:absolute; bottom:0; left:0; width:0; height:1px; background:#9370DB; transition:width 0.25s; }
        .ft-bot-link:hover { color:#d0b0f0; }
        .ft-bot-link:hover::after { width:100%; }

        .ft-pay {
          padding:4px 10px; border-radius:6px;
          background:rgba(147,112,219,0.15);
          border:1px solid rgba(147,112,219,0.25);
          font-size:11px; font-weight:700; color:#c4a0f0;
          letter-spacing:0.5px;
          transition:all 0.2s;
        }
        .ft-pay:hover { background:rgba(147,112,219,0.3); color:#f0e0ff; }

        .ft-heading {
          font-size:14px; font-weight:700; letter-spacing:1.6px;
          text-transform:uppercase; color:rgba(200,160,255,0.9);
          margin-bottom:20px; display:flex; align-items:center; gap:8px;
        }
        .ft-heading::after {
          content:''; flex:1; height:1px;
          background:linear-gradient(90deg,rgba(147,112,219,0.4),transparent);
        }
      `}</style>

      {/* decorative orbs */}
      <div style={{ position:'absolute', top:'-80px', left:'-80px', width:'280px', height:'280px', borderRadius:'50%', background:'radial-gradient(circle,rgba(139,69,19,0.25),transparent 70%)', animation:'floatOrb 8s ease-in-out infinite', pointerEvents:'none' }} />
      <div style={{ position:'absolute', bottom:'-60px', right:'-60px', width:'320px', height:'320px', borderRadius:'50%', background:'radial-gradient(circle,rgba(75,0,130,0.3),transparent 70%)', animation:'floatOrb 10s ease-in-out infinite reverse', pointerEvents:'none' }} />
      <div style={{ position:'absolute', top:'40%', left:'50%', width:'200px', height:'200px', borderRadius:'50%', background:'radial-gradient(circle,rgba(128,0,128,0.15),transparent 70%)', transform:'translateX(-50%)', pointerEvents:'none' }} />

      {/* Main grid */}
      <div style={{ maxWidth:1200, margin:'0 auto', padding:'52px clamp(16px,5vw,56px) 36px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:'40px 48px' }}>

          {/* Brand column */}
          <div style={{ gridColumn:'span 1' }}>
            <div style={{ marginBottom:16 }}>
              <p style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.65rem', fontWeight:800, color:'white', lineHeight:1, margin:0 }}>
                Twinkle<span style={{ color:'#C084FC' }}>Fanta</span>
              </p>
              <p style={{ fontSize:11, letterSpacing:'2px', color:'rgba(192,132,252,0.6)', textTransform:'uppercase', marginTop:4 }}>✦ magical shopping</p>
            </div>

            <p style={{ color:'rgba(200,180,220,0.65)', fontSize:13.5, lineHeight:1.75, marginBottom:20 }}>
              Your one-stop destination for amazing products crafted with love, delivered with magic.
            </p>

            {/* Socials */}
            <div style={{ display:'flex', gap:8 }}>
              {socials.map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" className="ft-social" aria-label={s.label}>
                  <svg viewBox="0 0 24 24"><path d={s.path} /></svg>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div className="ft-heading">
              <span>Explore</span>
            </div>
            <nav style={{ display:'flex', flexDirection:'column', gap:2 }}>
              {[
                { to:'/', label:'Home' },
                { to:'/products', label:'Products' },
                { to:'/categories', label:'Categories' },
                { to:'/about', label:'About Us' },
                { to:'/contact', label:'Contact' },
              ].map((l, i) => (
                <Link key={i} to={l.to} className="ft-link" onClick={() => {
                  window.scrollTo(0, 0);
                }}>{l.label}</Link>
              ))}
            </nav>
          </div>

          {/* Customer Service */}
          <div>
            <div className="ft-heading">
              <span>Support</span>
            </div>
            <nav style={{ display:'flex', flexDirection:'column', gap:2 }}>
              {/* FAQ link commented out
              <Link to="/faq" className="ft-link" onClick={() => window.scrollTo(0, 0)}>FAQ</Link>
              */}
              <Link to="/shipping-info" className="ft-link" onClick={() => window.scrollTo(0, 0)}>Shipping Info</Link>
              <Link to="/returns-policy" className="ft-link" onClick={() => window.scrollTo(0, 0)}>Returns Policy</Link>
              <Link to="/refund-policy" className="ft-link" onClick={() => window.scrollTo(0, 0)}>Refund Policy</Link>
              
              <Link to="/privacy-policy" className="ft-link" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
              <Link to="/terms-of-service" className="ft-link" onClick={() => window.scrollTo(0, 0)}>Terms of Service</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <div className="ft-heading">
              <span>Contact</span>
            </div>
            <div>
              {/* Address */}
              <div className="ft-contact-row">
                <div className="ft-contact-icon">
                  <svg fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                    <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                <div>
                  <p style={{ fontSize:11, fontWeight:700, letterSpacing:'0.8px', textTransform:'uppercase', color:'rgba(192,132,252,0.7)', marginBottom:3 }}>Address</p>
                  <p style={{ fontSize:13, color:'rgba(200,180,220,0.7)', lineHeight:1.6 }}>
                    NH 26, 1st floor, Pubji Toys,<br />
                    Near New Private Bus Stand,<br />
                    Jeypore, Koraput, Odisha - 764005
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="ft-contact-row">
                <div className="ft-contact-icon">
                  <svg fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498A1 1 0 0121 19v1a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                  </svg>
                </div>
                <div>
                  <p style={{ fontSize:11, fontWeight:700, letterSpacing:'0.8px', textTransform:'uppercase', color:'rgba(192,132,252,0.7)', marginBottom:3 }}>Phone</p>
                  <p style={{ fontSize:13, color:'rgba(200,180,220,0.7)', lineHeight:1.6 }}>
                    080-6964-5127<br />9938582696
                  </p>
                </div>
              </div>

              {/* Email */}
              <div className="ft-contact-row">
                <div className="ft-contact-icon">
                  <svg fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
                <div>
                  <p style={{ fontSize:11, fontWeight:700, letterSpacing:'0.8px', textTransform:'uppercase', color:'rgba(192,132,252,0.7)', marginBottom:3 }}>Email</p>
                  <p style={{ fontSize:13, color:'rgba(200,180,220,0.7)' }}>care@pubji.in</p>
                </div>
              </div>

              {/* Hours */}
              <div className="ft-contact-row">
                <div className="ft-contact-icon">
                  <svg fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 6v6l4 2"/>
                  </svg>
                </div>
                <div>
                  <p style={{ fontSize:11, fontWeight:700, letterSpacing:'0.8px', textTransform:'uppercase', color:'rgba(192,132,252,0.7)', marginBottom:3 }}>Hours</p>
                  <p style={{ fontSize:13, color:'rgba(200,180,220,0.7)', lineHeight:1.6 }}>Mon – Sat: 9AM – 6PM<br /><span style={{ color:'rgba(200,180,220,0.4)', fontSize:12 }}>Sunday: Closed</span></p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Divider shimmer */}
      <div className="ft-shimmer" style={{ height:1, background:'rgba(147,112,219,0.2)', margin:'0 clamp(16px,5vw,56px)' }} />

      {/* Bottom bar */}
      <div style={{ maxWidth:1200, margin:'0 auto', padding:'20px clamp(16px,5vw,56px) 28px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, flexWrap:'wrap' }}>

          {/* Copyright */}
          <p style={{ fontSize:12.5, color:'rgba(180,160,200,0.5)', margin:0 }}>
            © 2024 <span style={{ color:'rgba(192,132,252,0.7)', fontWeight:600 }}>PADMARANJEETA UNITED BABY JOY INDUSTRIS (PUBJI)</span>. All rights reserved.
          </p>

          {/* Payment methods */}
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:11, color:'rgba(180,160,200,0.45)', marginRight:4 }}>We Accept:</span>
            {['VISA', 'MC', 'UPI', 'EMI'].map((p, i) => (
              <span key={i} className="ft-pay">{p}</span>
            ))}
          </div>

          {/* Legal links */}
          <div style={{ display:'flex', gap:18, alignItems:'center' }}>
            <Link to="/terms-of-service" className="ft-bot-link" onClick={() => window.scrollTo(0, 0)}>Terms</Link>
            <span style={{ color:'rgba(147,112,219,0.3)', fontSize:10 }}>✦</span>
            <Link to="/privacy-policy" className="ft-bot-link" onClick={() => window.scrollTo(0, 0)}>Privacy</Link>
            <span style={{ color:'rgba(147,112,219,0.3)', fontSize:10 }}>✦</span>
            {/* Fixed: Sitemap link now properly uses 'to' prop instead of 'href' and includes onClick handler */}
            <Link 
              to="/sitemap" 
              className="ft-bot-link" 
              onClick={(e) => {
                // Prevent any default behavior and scroll to top
                window.scrollTo(0, 0);
              }}
            >
              Sitemap
            </Link>
          </div>
        </div>

        {/* Made with love */}
        <div style={{ textAlign:'center', marginTop:16, display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
          <span style={{ color:'rgba(180,160,200,0.35)', fontSize:11.5 }}>Crafted with</span>
          <span style={{ animation:'pulse 2s ease-in-out infinite', fontSize:13 }}>💜</span>
          <span style={{ color:'rgba(180,160,200,0.35)', fontSize:11.5 }}>by the Twinklefanta Team</span>
          <span style={{ color:'rgba(192,132,252,0.5)', fontSize:12, marginLeft:4 }}>✨</span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;